// Validation helpers for form inputs

/**
 * Formats phone input to only allow digits, max 10 characters
 * @param {string} value - Input value
 * @returns {string} - Cleaned phone number
 */
export function formatPhoneInput(value) {
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, '');
  // Limit to 10 digits
  return digits.slice(0, 10);
}

/**
 * Validates if a phone number has exactly 10 digits
 * @param {string} value - Phone value
 * @returns {boolean}
 */
export function isValidPhone(value) {
  const digits = value.replace(/\D/g, '');
  return digits.length === 10;
}

/**
 * Formats phone for display (e.g., 55 1234 5678)
 * @param {string} value - Phone value (digits only)
 * @returns {string} - Formatted phone
 */
export function formatPhoneDisplay(value) {
  const digits = value.replace(/\D/g, '');
  if (digits.length <= 2) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 2)} ${digits.slice(2)}`;
  return `${digits.slice(0, 2)} ${digits.slice(2, 6)} ${digits.slice(6, 10)}`;
}
